import { IOrder } from './order.model';

export interface IDeliveryCheckout {
  checked: boolean;
  checkedBy: string;
  checkedAt: Date | string;
}

export interface IDeliveryNotePosition {
  _id?: string;
  articlePosition: string; // Artikel / Pos. - manually entered
  rollCount: number; // Rollen
  piecesPerRoll: number; // Stck a'
  totalPieces: number; // Gesamt Stk. (calculated)
  folie1: number; // Folie 1 count
  folieN: number; // Folie N count
  folieA: number; // Folie A count
  dryP: number; // Dry P. count
  umCarton: number; // Um. Kt.
  ammopack: number; // Am. P.
  cartonCount: number; // Kt.
  weightKg: number; // kg
  note?: string; // optional remarks
  deliveryCheckout?: IDeliveryCheckout;
}

export interface IDeliveryNote {
  _id?: string;
  noteNumber: string;
  employeeId: string;
  shippingType: ShippingTypeEnum;
  order: IOrder;
  status: DeliveryStatusEnum;
  positions: IDeliveryNotePosition[];
  additionalInfo?: string;
  exportDate?: string | null;
  createdAt?: Date;
  updatedAt?: Date;
}

export enum DeliveryStatusEnum {
  DELIVERYNOTEQSCREATED = 'DELIVERYNOTEQSCREATED',
  READYFORDELIVERY = 'READYFORDELIVERY',
  DELIVERYNOTECREATED = 'DELIVERYNOTECREATED',
  DELIVERED = 'DELIVERED',
}

export enum ShippingTypeEnum {
  PALETTEDELIVERY = 'PALETTEDELIVERY',
  PARCELDELIVERY = 'PARCELDELIVERY',
}

// WebSocket notification interface
export interface DeliveryNoteNotification {
  id: string;
  noteNumber: string;
  action: 'created' | 'updated' | 'deleted' | 'statusChanged';
  status?: string;
  updatedBy?: string;
  timestamp: Date;
}
